/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQStudentOptionImageUrl } from './mCQStudentOptionImageUrl';
import type { MCQStudentOptionImageAlt } from './mCQStudentOptionImageAlt';

/**
 * MCQ option as shown to students (no correct answer or feedback).
 */
export interface MCQStudentOption {
  id: string;
  text: string;
  imageUrl?: MCQStudentOptionImageUrl;
  imageAlt?: MCQStudentOptionImageAlt;
}
